import { useCallback } from 'react'

import { Button, Menu } from 'govwell-ui'
import { AIChatbotFAQFragment } from 'types/graphql'

import CustomAnswerModal from 'src/components/AIAssistant/CustomAnswerModal'
import useDisclosure from 'src/hooks/use-disclosure'
import DeleteCustomAnswerModal from 'src/pages/AIAssistantTrainPage/DeleteCustomAnswerModal'
import { RefetchFnType } from 'src/types'

type Props = {
  aiChatbotFAQ: AIChatbotFAQFragment
  refetch: RefetchFnType
}

const CustomAnswersTableButtons = (props: Props) => {
  const { aiChatbotFAQ, refetch } = props

  const menuState = useDisclosure()
  const deleteModalState = useDisclosure()
  const editModalState = useDisclosure()

  const handleEditClick = useCallback(() => {
    editModalState.open()
    menuState.close()
  }, [editModalState, menuState])

  const handleDeleteClick = useCallback(() => {
    deleteModalState.open()
    menuState.close()
  }, [deleteModalState, menuState])

  return (
    <>
      <Menu isOpen={menuState.isOpen} onOpen={menuState.open} onClose={menuState.close}>
        <Menu.Trigger>
          <div className="inline-block">
            <Button variant="default" icon="FaChevronDown" ariaLabel="Actions" className="!px-2" />
          </div>
        </Menu.Trigger>
        <Menu.Content>
          <Menu.Item onClick={handleEditClick} icon="FaPencil">
            Edit
          </Menu.Item>
          <Menu.Item onClick={handleDeleteClick} icon="FaTrash" isDestructive>
            Delete
          </Menu.Item>
        </Menu.Content>
      </Menu>
      {deleteModalState.isOpen && (
        <DeleteCustomAnswerModal
          id={aiChatbotFAQ.id}
          onClose={deleteModalState.close}
          refetch={refetch}
        />
      )}
      {editModalState.isOpen && (
        <CustomAnswerModal
          modalType="edit"
          aiChatbotFAQ={aiChatbotFAQ}
          onSubmit={refetch}
          onClose={editModalState.close}
        />
      )}
    </>
  )
}

export default React.memo(CustomAnswersTableButtons)
